module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"water-tower\"-in-inglewood-california-40cf29fa4a5f4cad39ef28c537cc9838.png";